import { ReactNode } from "react";
import { FormFieldWrapper } from "./helpers/FieldWrapper";
import { TextAreaV2 } from "../inputs/Input";

interface IFormTextAreaProps {
  label: string;
  value: string;
  onChangeValue: (newValue: string) => void;
  required?: boolean;
  placeholder?: string;
  hint?: ReactNode;
  rows?: number;
  disabled?: boolean;
  error?: string | null;
}

/** @todo: should move to the hook one. */
export const FormTextArea = ({
  label,
  value,
  onChangeValue,
  required = false,
  placeholder,
  hint,
  rows,
  disabled,
  error = null
}: IFormTextAreaProps) => {
  return (
    <FormFieldWrapper
      label={label}
      requiredMark={required}
      error={error}
      hint={hint}
    >
      <TextAreaV2
        value={value}
        onChange={(e) => {
          onChangeValue(e.target.value);
        }}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
